export const SCHOOL = {
  name: "SANATÖLYE",
  tagline: "Sanat Akademisi",
  motto: "Daha güzel bir dünya için sanat",
  email: "bilgi@sanatolye.com.tr",
  phone: "0531 102 60 85",
  phoneHref: "05311026085",
  website: "www.sanatolye.com.tr",
  websiteHref: "https://www.sanatolye.com.tr",
  address: "Alibey Mahallesi, Turgut Özal Bulvarı No:12 A Silivri/İSTANBUL",
  hours: "Hafta içi 10:00 – 20:00 · Cumartesi 10:00 – 18:00",
  transport: "Merkezi konum ve kolay ulaşım",
  instagram: "@sanatolye",
};

export const NAV = [
  { id: "anasayfa", label: "Anasayfa" },
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "dersler", label: "Sanat Dalları" },
  { id: "neden", label: "Neden Biz" },
  { id: "galeri", label: "Galeri" },
  { id: "iletisim", label: "İletişim" },
];

export const MARQUEE = [
  "Müzik",
  "Resim",
  "Dans",
  "Daha Güzel Bir Dünya İçin Sanat",
  "Sanat Yaşamı Güzelleştirir",
  "Yaratıcılığın Adresi",
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Keşfet",
    text: "Müzik, resim ve dans… Çocuklar farklı sanat dallarını deneyerek kendilerine en yakın olanı keşfeder.",
    color: "text-gold",
  },
  {
    no: "02",
    title: "Üret",
    text: "İlk nota, ilk fırça darbesi, ilk adım. Her çocuk kendi eserini yaratarak öğrenir.",
    color: "text-coral",
  },
  {
    no: "03",
    title: "Paylaş",
    text: "Yıl sonu konserleri, sergiler ve gösteriler ile çocuklar emeğini sahnede paylaşır.",
    color: "text-lav",
  },
  {
    no: "04",
    title: "Büyü",
    text: "Sanat; dikkati, hayal gücünü ve özgüveni besler. Biz sanatla büyüyen bireyler yetiştiriyoruz.",
    color: "text-mint",
  },
];

export const BRANCH_FILTERS = [
  { id: "all", label: "Tümü" },
  { id: "muzik", label: "Müzik" },
  { id: "resim", label: "Resim" },
  { id: "dans", label: "Dans" },
];

export const LESSONS = [
  {
    id: "piyano",
    name: "Piyano",
    branch: "muzik",
    tag: "Müzik",
    desc: "Küçük parmaklar için renkli notalar. El-göz koordinasyonu ve melodi sevgisiyle başlıyoruz.",
    skills: ["Nota okuma", "Ritim duygusu", "İki el koordinasyonu"],
    image: "https://images.unsplash.com/photo-1577877777751-3f1ec20a0715?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-gold",
  },
  {
    id: "gitar",
    name: "Gitar",
    branch: "muzik",
    tag: "Müzik",
    desc: "İlk akorlar, ilk şarkılar! Çocuğunuz sevdiği melodileri kısa sürede çalmaya başlar.",
    skills: ["Akor geçişleri", "Şarkı eşliği", "Parmak gücü"],
    image: "https://images.unsplash.com/photo-1527236102507-6e5ac2692925?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-gold",
  },
  {
    id: "keman",
    name: "Keman",
    branch: "muzik",
    tag: "Müzik",
    desc: "Zarafet ve disiplinin buluştuğu enstrüman. Doğru duruş ve saf tınıyla başlangıç.",
    skills: ["Yay tekniği", "Kulak eğitimi", "Duruş & disiplin"],
    image: "https://images.unsplash.com/photo-1587794032575-de0040fe9186?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-gold",
  },
  {
    id: "bateri",
    name: "Bateri",
    branch: "muzik",
    tag: "Müzik",
    desc: "Enerjisi yüksek çocuklar için birebir! Ritim, koordinasyon ve bolca eğlence.",
    skills: ["Tempo kontrolü", "Kol-ayak uyumu", "Grup çalma"],
    image: "https://images.unsplash.com/photo-1678531730619-5c0cbb7735be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-gold",
  },
  {
    id: "san",
    name: "Şan & Solfej",
    branch: "muzik",
    tag: "Müzik",
    desc: "Doğru nefes, temiz ses. Kendi sesini keşfeden çocuklar sahnede parlar.",
    skills: ["Nefes teknikleri", "Ses açma", "Solfej"],
    image: "https://images.unsplash.com/photo-1502781252888-9143ba7f074e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-gold",
  },
  {
    id: "resim-atolye",
    name: "Çocuk Resim Atölyesi",
    branch: "resim",
    tag: "Resim",
    desc: "Boyalar, fırçalar ve sınırsız hayal gücü. En küçükler için renklerle tanışma atölyesi.",
    skills: ["Renk bilgisi", "El becerisi", "Yaratıcı ifade"],
    image: "https://images.unsplash.com/photo-1536221993589-9edbbca2c7fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-coral",
  },
  {
    id: "yagliboya",
    name: "Yağlıboya & Karakalem",
    branch: "resim",
    tag: "Resim",
    desc: "Temel çizim tekniklerinden yağlıboyaya. Gözlem, perspektif ve kompozisyon becerileri.",
    skills: ["Çizim teknikleri", "Perspektif", "Kompozisyon"],
    image: "https://images.pexels.com/photos/7025567/pexels-photo-7025567.jpeg?auto=compress&cs=tinysrgb&w=1200",
    accent: "bg-coral",
  },
  {
    id: "bale",
    name: "Bale",
    branch: "dans",
    tag: "Dans",
    desc: "Zarafet, duruş ve disiplin. Klasik bale ile çocuklar bedenini müzikle ifade etmeyi öğrenir.",
    skills: ["Duruş & denge", "Esneklik", "Müzikalite"],
    image: "https://images.unsplash.com/photo-1595348514401-eca68a3bea33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-lav",
  },
  {
    id: "yaratici-dans",
    name: "Yaratıcı Dans",
    branch: "dans",
    tag: "Dans",
    desc: "Modern ve özgür hareketlerle çocuklar enerjisini dansa dönüştürür, ritim duygusu gelişir.",
    skills: ["Koordinasyon", "Ritim & tempo", "Sahne özgüveni"],
    image: "https://images.unsplash.com/photo-1681456365855-a5e929013e06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "bg-lav",
  },
];

export const STATS = [
  { value: "12", suffix: "+", label: "Yıllık deneyim" },
  { value: "800", suffix: "+", label: "Mutlu öğrenci" },
  { value: "9", suffix: "", label: "Sanat dalı" },
  { value: "40", suffix: "+", label: "Sahne & sergi" },
];

export const FEATURES = [
  {
    icon: "GraduationCap",
    title: "Uzman Sanatçı Kadro",
    text: "Alanında deneyimli, çocukla iletişimi güçlü eğitmenlerle birebir ilgi.",
    color: "text-gold",
    bg: "bg-gold/10",
  },
  {
    icon: "Users",
    title: "Butik Sınıflar",
    text: "Az kişilik gruplar sayesinde her öğrenciye özel yaklaşım.",
    color: "text-coral",
    bg: "bg-coral/10",
  },
  {
    icon: "Sparkles",
    title: "Sahne & Sergi",
    text: "Yıl sonu konserleri, dans gösterileri ve resim sergileriyle sahne deneyimi.",
    color: "text-lav",
    bg: "bg-lav/10",
  },
  {
    icon: "Building2",
    title: "Modern Atölyeler",
    text: "Işıl ışıl, güvenli ve tam donanımlı müzik, resim ve dans stüdyoları.",
    color: "text-mint",
    bg: "bg-mint/10",
  },
  {
    icon: "CalendarClock",
    title: "Esnek Program",
    text: "Hafta içi ve hafta sonu farklı saat seçenekleriyle ailelere uygun plan.",
    color: "text-sky",
    bg: "bg-sky/10",
  },
  {
    icon: "Gift",
    title: "Ücretsiz Tanışma",
    text: "İlk deneme dersi ücretsiz; çocuğunuz sevdiği sanat dalını keşfetsin.",
    color: "text-gold",
    bg: "bg-gold/10",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Kızım resim atölyesine bayılıyor. Her hafta yeni bir eserle, kocaman bir gülümsemeyle eve geliyor.",
    author: "Ayşe K.",
    role: "Veli · Resim",
  },
  {
    quote: "Oğlum piyano derslerinden sonra çok daha özgüvenli. Sahnede çalarken gözlerindeki ışığı görmek paha biçilemez.",
    author: "Mehmet T.",
    role: "Veli · Müzik",
  },
  {
    quote: "Bale dersleri sayesinde duruşu ve disiplini gelişti. Öğretmenler gerçekten çocukları çok iyi anlıyor.",
    author: "Zeynep A.",
    role: "Veli · Dans",
  },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1577877777751-3f1ec20a0715?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "muzik", label: "Müzik" },
  { src: "https://images.pexels.com/photos/7025966/pexels-photo-7025966.jpeg?auto=compress&cs=tinysrgb&w=1000", cat: "resim", label: "Resim" },
  { src: "https://images.unsplash.com/photo-1595348514401-eca68a3bea33?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "dans", label: "Dans" },
  { src: "https://images.unsplash.com/photo-1527236102507-6e5ac2692925?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "sahne", label: "Sahne" },
  { src: "https://images.unsplash.com/photo-1536221993589-9edbbca2c7fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "resim", label: "Resim" },
  { src: "https://images.unsplash.com/photo-1678531730619-5c0cbb7735be?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "muzik", label: "Müzik" },
  { src: "https://images.unsplash.com/photo-1681456365855-a5e929013e06?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000", cat: "dans", label: "Dans" },
  { src: "https://images.pexels.com/photos/7025567/pexels-photo-7025567.jpeg?auto=compress&cs=tinysrgb&w=1000", cat: "resim", label: "Resim" },
];

export const GALLERY_FILTERS = [
  { id: "all", label: "Tümü" },
  { id: "muzik", label: "Müzik" },
  { id: "resim", label: "Resim" },
  { id: "dans", label: "Dans" },
  { id: "sahne", label: "Sahne" },
];
